(function() {
  function initUnifiedCart() {
    function getSavedVehicle() {
      try {
        const saved = localStorage.getItem('matrikar_vehicle');
        return saved ? JSON.parse(saved) : null;
      } catch { return null; }
    }

    function isVehicleConfirmed() {
      const v = getSavedVehicle();
      return !!(v && v.make && v.year && v.model);
    }

    function ensureVehicleProperties(form) {
      if (!form) return false;
      const vehicle = getSavedVehicle();
      if (!vehicle) return false;

      const props = [
        { key: 'vehicle', name: 'Vehicle', value: `${vehicle.make || ''} ${vehicle.model || ''} ${vehicle.sub || ''}`.trim() },
        { key: 'year',    name: 'Vehicle Year', value: vehicle.year || '' },
        { key: 'trim',    name: 'Trim', value: vehicle.sub || '' },
        { key: 'seats',   name: 'Seats', value: vehicle.seats ? `${vehicle.seats} seats` : '' },
        { key: 'drive',   name: 'Drive Side', value: vehicle.drive || '' },
        { key: 'fuel',    name: 'Fuel Type', value: vehicle.fuel || '' }
      ];

      for (const prop of props) {
        if (!prop.value) continue;
        let input = form.querySelector(`[data-mkvfit="${prop.key}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${prop.name}]`;
          input.setAttribute('data-mkvfit', prop.key);
          form.appendChild(input);
        }
        input.value = prop.value;
      }
      return true;
    }

    function showMessage(msg, isError = false) {
      let toast = document.getElementById('bundle-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.id = 'bundle-toast';
        Object.assign(toast.style, {
          position: 'fixed', bottom: '28px', left: '50%',
          transform: 'translateX(-50%) translateY(16px)',
          background: isError ? '#D71A23' : '#030213',
          color: '#fff', fontSize: '14px', fontWeight: '600',
          padding: '12px 24px', borderRadius: '4px',
          opacity: '0', transition: 'opacity .3s, transform .3s',
          zIndex: '99999', pointerEvents: 'none',
          fontFamily: 'inherit'
        });
        document.body.appendChild(toast);
      }
      toast.textContent = msg;
      toast.style.background = isError ? '#D71A23' : '#030213';
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
      clearTimeout(toast._timer);
      toast._timer = setTimeout(() => {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(-50%) translateY(16px)';
      }, 3000);
    }

    async function addItemToCart(variantId, sourceForm = null) {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      if (sourceForm) {
        for (let [key, value] of new FormData(sourceForm)) {
          if (key.startsWith('properties[')) {
            formData.append(key, value);
          }
        }
        ensureVehicleProperties(sourceForm);
        for (let [key, value] of new FormData(sourceForm)) {
          if (key.startsWith('properties[') && !formData.has(key)) {
            formData.append(key, value);
          }
        }
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      if (!response.ok) throw new Error(`Failed to add variant ${variantId}`);
      return response.json();
    }

    async function refreshCartCount() {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const count = cart.item_count;
      document.querySelectorAll('.cart-count, .cart__count, .cart-item-count, [data-cart-count], .header__cart-count, .cart-count-bubble')
        .forEach(el => { if (el) el.textContent = count; });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    function openCartDrawer() {
      const cartIcon = document.querySelector('[data-cart-drawer-toggle], .cart-drawer-toggle, .header__icon--cart, .site-header__cart, a[href="/cart"]');
      if (cartIcon) {
        cartIcon.click();
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    }

    async function addMainAndBundleToCart(event) {
      if (event) event.preventDefault();

      if (!isVehicleConfirmed()) {
        showMessage('Please select & confirm your vehicle first', true);
        return false;
      }

      const mainForm = document.querySelector('form[action*="/cart/add"][id^="product-form-main"], form[action*="/cart/add"]');
      if (!mainForm) {
        showMessage('Main product form not found', true);
        return false;
      }

      const variantInput = mainForm.querySelector('input[name="id"]');
      let mainVariantId = variantInput ? variantInput.value : null;
      if (!mainVariantId) {
        const selectedOption = mainForm.querySelector('select[name="id"] option:checked');
        if (selectedOption) mainVariantId = selectedOption.value;
      }
      if (!mainVariantId) {
        showMessage('Could not determine main product variant', true);
        return false;
      }

      const bundleCheckboxes = document.querySelectorAll('#bundleProductsContainer .bundle-checkbox-input:checked');
      const bundleVariantIds = Array.from(bundleCheckboxes).map(cb => cb.dataset.variantId).filter(v => v);

      const allButtons = document.querySelectorAll('.bundle-add-btn, .mk-cta-btn, .mkv2-snav-btn, mkv3-snav-btn, .mkp-snav-btn, button[type="submit"][form*="product-form"]');
      allButtons.forEach(btn => { btn.disabled = true; btn.textContent = 'Adding...'; });

      try {
        await addItemToCart(parseInt(mainVariantId, 10), mainForm);
        // HOTFIX_BUNDLE_SYSTEM_V22 — propager vehicle properties (Vehicle, Year, Trim, Seats, Drive, Fuel)
        // sur chaque bundle item via mainForm comme sourceForm. ensureVehicleProperties() relit localStorage.
        for (const vid of bundleVariantIds) {
          await addItemToCart(parseInt(vid, 10), mainForm);
        }
        await refreshCartCount();
        const bundleCount = bundleVariantIds.length;
        showMessage(bundleCount ? `Main product + ${bundleCount} bundle item(s) added!` : 'Product added to cart!');
        openCartDrawer();
        return true;
      } catch (err) {
        console.error(err);
        showMessage('Something went wrong. Please try again.', true);
        return false;
      } finally {
        allButtons.forEach(btn => {
          btn.disabled = false;
          if (btn.classList.contains('bundle-add-btn')) btn.textContent = 'Add Bundle to Cart';
          else if (btn.classList.contains('mk-cta-btn')) btn.textContent = btn.getAttribute('data-original-label') || 'CONFIGURE YOURS';
          else if (btn.classList.contains('mkv2-snav-btn')) btn.textContent = 'Add to cart';
          else if (btn.classList.contains('mkv3-snav-btn')) btn.textContent = 'Add to cart';
          else if (btn.classList.contains('mkp-snav-btn')) btn.textContent = 'Add to Cart';
          else if (btn.closest('form')) btn.textContent = 'Add to Cart';
        });
      }
    }

    const mainForm = document.querySelector('form[action*="/cart/add"][id^="product-form-main"], form[action*="/cart/add"]');
    if (mainForm) {
      mainForm.addEventListener('submit', addMainAndBundleToCart);
    }

    const bundleBtn = document.getElementById('addBundleBtn');
    if (bundleBtn) {
      const newBundleBtn = bundleBtn.cloneNode(true);
      bundleBtn.parentNode.replaceChild(newBundleBtn, bundleBtn);
      newBundleBtn.addEventListener('click', addMainAndBundleToCart);
    }

    const ctaBtn = document.getElementById('mk-cta-atc-btn');
    if (ctaBtn) {
      const newCtaBtn = ctaBtn.cloneNode(true);
      newCtaBtn.setAttribute('data-original-label', newCtaBtn.textContent);
      ctaBtn.parentNode.replaceChild(newCtaBtn, ctaBtn);
      newCtaBtn.addEventListener('click', addMainAndBundleToCart);
    }

    const stickyV2Btn = document.querySelector('.mkv2-snav-btn[data-snav-atc]');
    if (stickyV2Btn) {
      const newStickyV2 = stickyV2Btn.cloneNode(true);
      stickyV2Btn.parentNode.replaceChild(newStickyV2, stickyV2Btn);
      newStickyV2.addEventListener('click', addMainAndBundleToCart);
    }

    const stickyV3Btn = document.querySelector('.mkv3-snav-btn[data-snav-atc]');
    if (stickyV3Btn) {
      const newStickyV3 = stickyV3Btn.cloneNode(true);
      stickyV3Btn.parentNode.replaceChild(newStickyV3, stickyV3Btn);
      newStickyV3.addEventListener('click', addMainAndBundleToCart);
    }

    const mkpStickyBtn = document.querySelector('.mkp-snav-btn');
    if (mkpStickyBtn) {
      const newMkpSticky = mkpStickyBtn.cloneNode(true);
      mkpStickyBtn.parentNode.replaceChild(newMkpSticky, mkpStickyBtn);
      newMkpSticky.addEventListener('click', addMainAndBundleToCart);
    }

    document.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(btn => {
      if (btn.closest('form') === mainForm) return;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        addMainAndBundleToCart();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUnifiedCart);
  } else {
    initUnifiedCart();
  }
})();
